import React, { useState } from 'react';

import { SimpleTooltip } from '@eluve/components';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  Icon,
  Textarea,
  useToast,
} from '@eluve/components';

type SetFactsFunction = (facts: string) => void;

interface CSVForFactsProps {
  setFacts: SetFactsFunction;
}

const CSVForFacts: React.FC<CSVForFactsProps> = ({ setFacts }) => {
  const [csvContent, setCsvContent] = useState('');
  const toast = useToast();
  const handleImport = () => {
    toast.success('CSV updated');
    setFacts(csvContent);
    setCsvContent('');
  };

  return (
    <AlertDialog>
      <SimpleTooltip label="Import Facts">
        <AlertDialogTrigger asChild>
          <Button variant="outline">
            <Icon name="FileUp" size="auto" />
          </Button>
        </AlertDialogTrigger>
      </SimpleTooltip>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-text-secondary">
            TSV of Facts
          </AlertDialogTitle>
          <AlertDialogDescription>
            Paste your TSV content in the field below.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Textarea
          value={csvContent}
          onChange={(e) => setCsvContent(e.target.value)}
          placeholder="Paste tab-separated value (TSV) content here..."
          rows={10}
        />

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-bg-accent-strong-primary text-text-accent-strong hover:bg-bg-accent-strong-primary/90"
            onClick={handleImport}
          >
            Update
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CSVForFacts;
